import logger from "@utils/logger";
import { ensureFreshAccessToken } from "@utils/tokenManager";
const backendUrl = process.env.REACT_APP_BACKEND_BASE_URL;

const getHeaders = (token, isJson = true) => ({
  ...(isJson && { "Content-Type": "application/json" }),
  Authorization: token ? `Bearer ${token}` : undefined,
});

export const apiRequest = async ({ method = "GET", endpoint, body = null, tokenRequired = true, isJson = true }) => {
  try {
    if (tokenRequired) await ensureFreshAccessToken();
    const token = localStorage.getItem("access_token");

    logger.info(`[${method}] ${endpoint}`);

    const response = await fetch(`${backendUrl}${endpoint}`, {
      method,
      headers: getHeaders(tokenRequired ? token : null, isJson),
      ...(body && { body: JSON.stringify(body) }),
    });

    const data = await response.json();

    if (!response.ok) {
      logger.error(`Request failed: ${data.message || data.details}`);
      throw new Error(data.message || data.details || "Unknown error");
    }

    logger.info(`Request succeeded: ${endpoint}`);
    return data; 
  } catch (err) {
    logger.error(`apiRequest error: ${err.message}`);
    throw err;
  }
};

export const apiFetch = async (endpoint, options = {}) => {
  try {
    await ensureFreshAccessToken();
    const token = localStorage.getItem("access_token");

    const method = options.method || "GET";
    logger.info(`[${method}] ${endpoint}`);

    const response = await fetch(`${backendUrl}${endpoint}`, {
      ...options,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        ...options.headers,
      },
    });

    const data = await response.json();

    if (!response.ok) {
      logger.error(`Request failed: ${data.message || data.details}`);
      throw new Error(data.message || data.details || "Unknown error");
    }

    logger.info(`Request succeeded: ${endpoint}`);
    return data;
  } catch (err) {
    logger.error(`apiFetch error: ${err.message}`);
    throw err;
  }
};
